if (!customElements.get('truncate-text')) {
  customElements.define('truncate-text', class TruncateText extends HTMLElement {
    constructor() {
      super();
      if (this.dataset.ignore) return;

      this.button = this.querySelector('.button--truncate-text-js');
      this.buttonWrapper = this.querySelector('.truncate-text__button-wrapper');
      this.contentWrapper = this.querySelector('.truncate-text__content-wrapper');
      this.content = this.querySelector('.truncate-text__content');
      this.label = this.button?.querySelector('[data-truncate-label], span');
    }

    connectedCallback() {
      if (!this.button || !this.buttonWrapper || !this.contentWrapper || !this.content || this.abortController) return;

      this.abortController = new AbortController();
      const signal = this.abortController.signal;
      this.expandLabel = this.button.dataset.expandLabel || this.label?.textContent.trim() || '';
      this.collapseLabel = this.button.dataset.collapseLabel || this.expandLabel;
      this.button.setAttribute('aria-expanded', 'false');
      this.button.addEventListener('click', (event) => this.onClickButton(event), { signal });
      window.addEventListener('resize', () => this.calculateHeight(), { signal });
      this.calculateHeight();
    }

    disconnectedCallback() {
      this.animation?.cancel();
      this.abortController?.abort();
      this.abortController = null;
    }

    onClickButton(event) {
      event.preventDefault();
      event.stopPropagation();
      this.setExpanded(this.button.getAttribute('aria-expanded') !== 'true');
    }

    setExpanded(expanded, animate = true) {
      this.animation?.cancel();
      this.button.setAttribute('aria-expanded', String(expanded));
      if (this.label) this.label.textContent = expanded ? this.collapseLabel : this.expandLabel;

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!animate || reducedMotion) {
        this.contentWrapper.classList.toggle('expand', expanded);
        this.contentWrapper.style.removeProperty('max-height');
        return;
      }

      const startHeight = this.contentWrapper.getBoundingClientRect().height;
      const collapsedHeight = Number.parseFloat(getComputedStyle(this).getPropertyValue('--truncate-text-length'));
      const endHeight = expanded ? this.content.scrollHeight : collapsedHeight;

      this.contentWrapper.classList.remove('expand');
      this.contentWrapper.style.maxHeight = `${startHeight}px`;
      this.animation = this.contentWrapper.animate(
        [{ maxHeight: `${startHeight}px` }, { maxHeight: `${endHeight}px` }],
        { duration: 420, easing: 'cubic-bezier(.22, 1, .36, 1)' }
      );

      this.animation.finished.then(() => {
        this.contentWrapper.classList.toggle('expand', expanded);
        this.contentWrapper.style.removeProperty('max-height');
        this.animation = null;
      }).catch(() => {});
    }

    calculateHeight() {
      const collapsedHeight = Number.parseFloat(getComputedStyle(this).getPropertyValue('--truncate-text-length'));
      if (!Number.isFinite(collapsedHeight)) return;

      const isOverflowing = this.content.scrollHeight > collapsedHeight + 1;
      this.buttonWrapper.classList.toggle('hidden', !isOverflowing);
      if (!isOverflowing && this.button.getAttribute('aria-expanded') === 'true') {
        this.setExpanded(false, false);
      }
    }
  });
}
